import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import Layout from '../../common/layout';
import UserFilter from './forms/userFilter';
import UserGrid from './user-grid';
import { GET_DEPARTMENTS, GET_SYSTEM_ROLES, GET_MEMBERS_QUERY } from '../gql';

function Users(): JSX.Element {
  const [roles, setRoles] = useState<
    Array<{ displayName: string; id: string }>
  >([]);
  const [departments, setDepartments] = useState<
    Array<{ displayName: string; id: string }>
  >([]);
  const [filter, setFilter] = useState<{
    name: string;
    designation: string;
    roles: string[];
    departments: string[];
  }>({
    name: '',
    designation: 'All',
    roles: [],
    departments: []
  });

  const { data: systemRolesData } = useQuery(GET_SYSTEM_ROLES);
  const { data: departmentsData } = useQuery(GET_DEPARTMENTS);
  const { data, refetch, loading } = useQuery(GET_MEMBERS_QUERY, {
    variables: {
      displayName: filter.name,
      jobTitles: filter.designation !== 'All' ? [filter.designation] : [],
      roles: filter.roles.includes('All') ? [] : filter.roles,
      departments: filter.departments.includes('All') ? [] : filter.departments
    }
  });

  useEffect(() => {
    if (systemRolesData) {
      setRoles(systemRolesData.getSystemRoles);
    }
  }, [systemRolesData]);

  useEffect(() => {
    if (departmentsData) {
      setDepartments(departmentsData.getDepartments);
    }
  }, [departmentsData]);

  useEffect(() => {
    void refetch();
  }, [filter]);

  const getMemebers = (): [] => {
    if (!data) {
      return [];
    }
    return data.getMembers.data;
  };

  return (
    <Layout mainHeading="Users" subHeading="User Management > Users">
      <UserFilter
        filter={filter}
        setFilter={setFilter}
        roles={roles}
        departments={departments}
      />
      <UserGrid
        users={getMemebers()}
        systemDepartments={departments}
        systemRoles={roles.filter((role) => role.displayName !== 'Super admin')}
        loading={loading}
      />
    </Layout>
  );
}

export default Users;
